import { queryBot2 } from 'boot/axios';

export async function loadProjectDocuments (projectId) {
    return queryBot2('loadProjectDocuments', { projectId }).then((r) => {
        let document;
        const result = r.data;
        if (result && typeof result === 'object') {
            document = result;
        }
        return document;
    });
}

export async function loadProjectDocumentById (id) {
    return queryBot2('loadProjectDocumentById', { id }).then((r) => {
        let document;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            document = result;
        }
        return document;
    });
}

export async function loadProjectDocument (value) {
    const { projectId, documentId } = value;
    return queryBot2('loadProjectDocument', { projectId, documentId }).then((r) => {
        let document;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            document = result;
        }
        return document;
    });
}

export async function loadPortfolioDocuments (portfolioId) {
    return queryBot2('loadPortfolioDocuments', { portfolioId }).then((r) => {
        let document;
        const result = r.data;
        if (result && typeof result === 'object') {
            document = {};
            result.forEach(i => {
                document[i.document_id] = i;
            });
        }
        return document;
    });
}

export async function loadLastPortfolioDocument () {
    return queryBot2('loadLastPortfolioDocument').then((r) => {
        let document;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            document = result;
        }
        return document;
    });
}

export async function loadPortfolioDocumentById (id) {
    return queryBot2('loadPortfolioDocumentById', { id }).then((r) => {
        let document;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            document = result;
        }
        return document;
    });
}

export async function loadPortfolioDocument (value) {
    const { portfolioId, documentId } = value;
    return queryBot2('loadPortfolioDocument', { portfolioId, documentId }).then((r) => {
        let document;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            document = result;
        }
        return document;
    });
}

export async function loadDocuments () {
    return queryBot2('loadDocuments').then((r) => {
        let document;
        const result = r.data;
        if (result && typeof result === 'object') {
            document = result;
        }
        return document;
    });
}

export async function loadLastDocument () {
    return queryBot2('loadLastDocument').then((r) => {
        let document;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            document = result;
        }
        return document;
    });
}

export async function loadDocumentById (id) {
    return queryBot2('loadDocumentById', { id }).then((r) => {
        let document;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            document = result;
        }
        return document;
    });
}

export default loadDocumentById;
